import React from 'react'
import { Box, Typography, Button, Grid } from '@mui/material'

const ButtonPanel: React.FC = () => {
  // Define button colors, sizes, and states
  const buttonColors: Array<'primary' | 'success' | 'error' | 'warning'> = [
    'primary',
    'success',
    'error',
    'warning',
  ]
  const buttonSizes: Array<'small' | 'medium' | 'large'> = ['small', 'medium', 'large']

  // Define type for button states and structure of state array
  interface ButtonState {
    state: 'Enabled' | 'Disabled' | 'Loading'
    disabled: boolean
    loading: boolean
  }

  const buttonStates: ButtonState[] = [
    { state: 'Enabled', disabled: false, loading: false },
    { state: 'Disabled', disabled: true, loading: false },
    { state: 'Loading', disabled: false, loading: true },
  ]

  return (
    <Box sx={{ padding: '2rem' }}>
      <Typography variant='h4' gutterBottom>
        Button Panel
      </Typography>
      {buttonSizes.map((size) => (
        <Box key={size} sx={{ marginBottom: '2rem' }}>
          <Typography variant='subtitle1' gutterBottom>
            {size.charAt(0).toUpperCase() + size.slice(1)} Size
          </Typography>
          {buttonStates.map(({ state, disabled, loading }) => (
            <Box key={`${size}-${state}`} sx={{ marginBottom: '1.5rem' }}>
              <Typography variant='subtitle2' gutterBottom>
                {state} State
              </Typography>
              <Grid container spacing={2}>
                {buttonColors.map((color) => (
                  <Grid size={{ xs: 12, sm: 6, md: 4 }} key={`${color}-${size}-${state}`}>
                    <Button
                      variant={state === 'Enabled' ? 'contained' : 'outlined'}
                      color={color}
                      size={size}
                      disabled={disabled}
                      onClick={() =>
                        !disabled &&
                        !loading &&
                        alert(`${color.charAt(0).toUpperCase() + color.slice(1)} ${size} Button Clicked`)
                      }
                    >
                      {loading
                        ? 'Loading...'
                        : `${color.charAt(0).toUpperCase() + color.slice(1)} ${size} Button`}
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  )
}

export default ButtonPanel
